import { StringUtils } from "@dtm-frontend/shared/utils";
import { Credit, UrlTemplateImageryProvider } from "cesium";

export interface GeotilerImageryProviderOptions {
    url: string;
    credit: string;
}

export class GeotilerImageryProvider extends UrlTemplateImageryProvider {
    constructor(private readonly options: GeotilerImageryProviderOptions) {
        super({ url: options.url });
    }

    public getTileCredits() {
        return [new Credit(this.prepareCreditText(this.options.credit), true)];
    }

    private prepareCreditText(credit: string): string {
        const year = new Date().getFullYear().toString();

        return StringUtils.replaceInTemplate(credit, { year });
    }
}
